import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMaterial from "vue-material";

import App from './App.vue'

import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";

Vue.use(VueMaterial);
Vue.use(VueRouter);

const linkActiveClass = 'my-link-active-class'

Vue.config.productionTip = false;
Vue.material.router.linkActiveClass = linkActiveClass

const router = new VueRouter({
  routes: [
    { path: '/', component: App },
  ],
  mode: 'history'
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
